import { createSelector } from 'reselect'
import { useSelector } from 'react-redux'

import { getUserIdentity } from '~/redux-modules/identity'
import { PURCHASED } from '~/lib/quoteStatuses'
import { checkQuantityRangeAvailability } from '~/apps/consumer/pages/Quotes/Builder/QuotesHomePage/QuoteCheckoutSummary/logic'
import { PROVISIONED_UI_FLAGS } from '~/apps/consumer/pages/Quotes/Builder/QuoteDetailPage/logic'
import isFlagEnabled from '~/lib/isFlagEnabled'
import { FictivStateType } from '~/redux-modules/fictivStateType'

import { stateType } from './types'

/**
 * @deprecated Assume flag is always true
 */
export const isQueryDetailsQueryRefactorOn = (state: stateType) =>
    isFlagEnabled(
        getUserIdentity(state),
        PROVISIONED_UI_FLAGS.QUOTE_DETAILS_QUERY_REFACTOR,
        'true',
    )

export const QuoteCheckoutSummaryButtonSelector = createSelector(
    getUserIdentity,
    (state: stateType) => state.dfmLayers.quote,
    isQueryDetailsQueryRefactorOn,

    (identity, quote, isQueryRefactorEnabled) => {
        if (!quote || !identity) {
            return {}
        }

        const isPurchaserOfQuote = identity.id === quote.user.id
        const isAdmin = identity.isAdmin
        const isQuoteCollaborator =
            quote.platformOrder?.purchaserUserId !== quote?.user.id
        const isUserHasAccessToQuote =
            isPurchaserOfQuote || isAdmin || isQuoteCollaborator
        const orderName = quote.platformOrder?.name
        const isPlatformOrderPlaced = quote.status === PURCHASED
        const shouldShowViewOrderDetailsButton =
            isPlatformOrderPlaced && isUserHasAccessToQuote
        const isAnyQuoteQuantityRangeUnavailable: boolean =
            checkQuantityRangeAvailability(quote.quoteModels)

        return {
            isUserHasAccessToQuote,
            orderName,
            isPlatformOrderPlaced,
            shouldShowViewOrderDetailsButton,
            isAnyQuoteQuantityRangeUnavailable,
            isQueryRefactorEnabled,
        }
    },
)

export const getLineQuantityErrorStatus =
    (quoteId: string) => (state: stateType) =>
        Object.entries(
            state?.quoteDetail?.[quoteId]?.lineQuantityErrors ?? {},
        ).some(([, value]: [string, boolean]) => value)

export const getMaxLeadTimeDays =
    (quoteId: string) =>
    (state: stateType): number =>
        state?.quoteDetail?.[quoteId]?.maxLeadTimeDays ?? 0

export const useGetSelectedShippingOption = (quoteId?: string) => {
    return useSelector((state: FictivStateType) => {
        quoteId =
            quoteId ||
            state.queryRefactor.coreQuoteDetails.coreQuoteDetailsData?.id
        return typeof quoteId === 'undefined'
            ? null
            : state.quoteDetail[quoteId]?.selectedShippingOption
    })
}
